export const SELECT_READER = 'terminal/SELECT_READER';
export const SELECT_READER_CANCEL = 'terminal/SELECT_READER_CANCEL';
export const SELECT_READER_DONE = 'terminal/SELECT_READER_DONE';
export const READER_CONNECT_SUCCESS = 'terminal/READER_CONNECT_SUCCESS';
export const NO_AVAILABLE_READERS = 'terminal/NO_AVAILABLE_READERS';
export const DISCOVER_READERS = 'terminal/DISCOVER_READERS';
export const PAYMENT_STATUS_CHANGE = 'terminal/PAYMENT_STATUS_CHANGE';
export const OPEN_WAITING_FOR_CARD = 'terminal/OPEN_WAITING_FOR_CARD';
export const CLOSE_WAITING_FOR_CARD = 'terminal/CLOSE_WAITING_FOR_CARD';
export const SET_EXTERNAL_PAYMENT_INFO = 'terminal/SET_EXTERNAL_PAYMENT_INFO';
export const READY_TO_PAY = 'terminal/READY_TO_PAY';
export const READY_TO_REFUND = 'terminal/READY_TO_REFUND';
